import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 35.054 35.054"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "var(--stroke-0, white)",
      "stroke-opacity": ".2",
      d: "M17.527 34.554c9.404 0 17.027-7.623 17.027-17.027S26.931.5 17.527.5.5 8.123.5 17.527s7.623 17.027 17.027 17.027Z"
    }, null, -1)
  ]))]))
}
export default { render: render }